export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());

export const isRequired = (v) => String(v ?? "").trim().length > 0;
